import { render } from "./AppointmentsFeed.vue?vue&type=template&id=ded47d02&scoped=true&ts=true"
import script from "./AppointmentsFeed.vue?vue&type=script&lang=ts"
export * from "./AppointmentsFeed.vue?vue&type=script&lang=ts"

import "./AppointmentsFeed.vue?vue&type=style&index=0&id=ded47d02&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded47d02"]])

export default __exports__